import React, {useContext} from "react";
import { NavigateWayContext } from '../store/NavigateWayContext';
import "../styles/addRoom.css";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as NewRoom } from '../img/newRoom.svg'
import axiosInstance from "../auth/axiosInstance";
import chevron from "../img/Chevron White.svg";
import { Input } from "../components/input/input";
import ModalAddedItems from "../components/modalAddedItens/modalAddedItens";
import { Tabs } from "../components/Tabs/tabs";
import FooterStatus from "../components/footerStatus/footerStatus";
import { useMsal } from "@azure/msal-react";
import { Button } from "../components/button/button";
import ModalChurned from "../components/modalChurned/modalChurned";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";
import { Header } from "../components/header/header";
import { useStore } from '../store/useStore';

function AddRoom() {
  const { siteData, fetchData } = useStore()
  const location = useLocation();
  const navigate = useNavigate();
  const [values, setValues] = React.useState({});
  const [clients, setClients] = React.useState([]);
  const [arrPost, setArrPost] = React.useState([]);
  const [showData, setShowData] = React.useState(false);
  const options = ['Added', 'Churned']
  const types = ["Yes", "No"];
  const [selected, setSelected] = React.useState(`Added`)
  const [showFeedback, setShowFeedback] = React.useState(false);
  const [openModalChurned, setOpenModalChurned] = React.useState(false);
  const [openModalAdded, setOpenModalAdded] = React.useState(false);
  const [dataRacks, setDataRacks] = React.useState([]);
  const [initialDataRacks, setInitialDataRacks] = React.useState([]);
  const params = location.state
  const [cages, setCages] = React.useState([]);
  const [pdus, setPdus] = React.useState({})
  const [textStatus, setTextStatus] = React.useState('Successfully registered count, wait for the feedback.')
  const [disableSendBtn, setDisableSendBtn] = React.useState(false);
  const onChange = (event) => {
    setValues({ ...values, [event.target.name]: event.target.value });
  };
  const [added, setAdded] = React.useState([]);
  const [emptyAdded, setEmptyAdded] = React.useState([]);
  const [churned, setChurned] = React.useState([]);

  const [size, setSize] = React.useState({
    showInDesk: window.innerWidth >= 1024,
    showInMobile: window.innerWidth < 1024,
  })

  // VARIAVEL GLOBAL QUE CONTROLA A NAVEGAÇÃO ENTRE AS PÁGINAS DO FLUXO
  const { navigateWay } = useContext(NavigateWayContext);
  // navigateWay = {site: '/', room: '', rack: '', map: '', newcount: '', diagram: ''}

  const handleResize = () => {
    setSize({
      ...size,
      showInDesk: window.innerWidth >= 1024,
      showInMobile: window.innerWidth < 1024
    });
  };

  React.useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function getData() {
    axiosInstance(`racks/room/${location.state.idRoom}`).then((res) => {
      setDataRacks(res.data)
      setInitialDataRacks(res.data)
    }).catch((err) => console.log(err));

    axiosInstance(`clients`).then((res) => {
    const sortedData = res.data.sort((a, b) => a.client.localeCompare(b.client));
    
    setClients(sortedData);
    }).catch((err) => console.log(err));

    axiosInstance(`cages`).then((res) => {
      setCages(res.data);
    }).catch((err) => console.log(err));

  }

  const { accounts } = useMsal()

  function postLog(text) {
    axiosInstance.post('logs', {
      email: accounts[0].username,
      name: accounts[0].name,
      action: text
    })
      .catch(err => console.log(err))
  }

  function addArrPost(event) {
    event.preventDefault();
    const combinedAddeds = [
      ...added,
      ...emptyAdded.filter(
        newItem => !added.some(
          existingItem => existingItem.nrack === newItem.nrack && existingItem.nscala === newItem.nscala
        )
      )
    ];
    let obj = {
      room_id: location.state.idRoom,
      cage_id: values.cage_id,
      client_id: values.client_id,
      addeds: combinedAddeds,
      churneds: churned,
      pdu: pdus
    };

    if ((added.length > 0 || churned.length > 0) && values.client_id) {
      setArrPost((total) => { return [...total, obj] });
      setShowData(true);
      setPdus({})
      setAdded([]);
      setEmptyAdded([])
      setChurned([]);
    }
  }

  function postRack(event) {
    setDisableSendBtn(false)
    event.preventDefault();
    if (arrPost.length > 0) {
      arrPost.forEach((value, i) => {
        axiosInstance.post("count", value).then((res) => {
          if (res.status === 201 && i + 1 === arrPost.length) {
            setTimeout(() => {
              setShowFeedback(false);
              // navigate(`/site/${params.dc}/${params.id}`, { state: location.state });
            }, 10000);
            fetchData('count', 'countData');
            setChurned([]);
            setTextStatus('Successfully registered count, wait for the feedback.')
            setShowFeedback(true);
            setDisableSendBtn(true);
          }
        }).catch((err) => console.log(err));
      });
      postLog(`Created a Rack Count in ${params.dc}`)
    }
  }

  React.useEffect(() => {
    getData();
  }, []);

  function selectedTypes(val) {
    setSelected(val)
    let filterDataReserved = []
    if (val === 'Added') {
      filterDataReserved = initialDataRacks.filter(el => el.reserved)
    }
    const filterData = initialDataRacks.filter(el => val === 'Churned' ? el.status : !el.status).concat(filterDataReserved)
    setDataRacks(filterData)
    setOpenModalChurned(true)
  }

  function postNewCage(e) {
    e.preventDefault()

    axiosInstance.post('cages', { name: values.cage })
      .then(res => {
        setTextStatus('Successfully registered cage')
        setShowFeedback(true);
        setTimeout(() => {
          setShowFeedback(false);
        }, 10000);
        setValues({ ...values, cage_id: res.data.idCage })
        setCages([...cages, res.data])
      })
      .catch(err => {
        console.log(err)
      })
  }

  return (
    <section className="tech-body" style={{width:"95%"}}>
      <Header line>
        <Breadcrumb
          site={true}
          room={true}
          map={true}
          newcount={true}
          diagram={false}
        />
      </Header>

      <div style={{ display: 'flex', gap: 15, alignItems: "center" }}>
        <div className="title-add-room-area_div">
          <h2>Able Month -</h2>
          <h1>
            {new Date().toLocaleDateString("en", { month: "long" })} /{" "}
            {new Date().getFullYear()}
          </h1>
        </div>
      </div>

      {showData ?
        <section style={{ height: '90%', marginTop: 70 }}>
          <div style={{
            width: "100%",
            justifyContent: "center",
            display: "flex",
            marginBottom: 20,
            marginTop: 20,
          }}>
            <Button onClick={() => setShowData(false)} style={{ borderRadius: "30px", padding: "0 20px" }} label=" + Add other rack count" />
          </div>
          <section className="rooms-area-container-addrack-list" >
            {arrPost.map((value, i) => {
              return (
                <div className="card-area-view-list">
                  <div className="card-area-view-list_div">
                    <h2>Count {i + 1}</h2>
                    <h3>Addeds Quantity {value.addeds.length} | Churneds Quantity {value.churneds.length}</h3>
                  </div>
                  <div className="card-area-view-list_div">
                    <h2>Cage</h2>
                    <h3>{!!value.cage_id ? 'Yes' : "No Cage"}</h3>
                  </div>
                </div>
              );
            })}
          </section>
          <Button
            disabled={disableSendBtn}
            onClick={(e) => postRack(e)}
            style={{
              width: "100%",
              background: "#0F0742",
              color: "#fff",
              height: "50px",
            }}
            label="Send Count"
          />
        </section>
        :
        <section style={{ height: '100%' }}>
          <section className="add-rack-content">
            <form onSubmit={(e) => addArrPost(e)} className="form-area">
              <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                <div className="first-div-form-tech">
                  <Input style={{ width: '90%', maxWidth: 400 }} onChange={onChange} name="client_id" title="Select Client" required tag="select" >
                      <option >Select a client</option>
                      <option value='76AB50F4-6204-49ED-8613-7307EBC2E18A'>AVAILABLE RACK</option>
                      {clients.map((value) => {
                        if(value.client == 'AVAILABLE RACK'){
                          return null
                        } else {
                          return <option value={value.id}>{value.client}</option>;
                        }
                      })}
                  </Input>
                  
                  <div className="row-area-churned-area">
                    <div style={{ display: "flex" }}>
                      <h2>Cage</h2>
                      <h4 style={{ color: "#D95050", marginLeft: 4 }}>*</h4>
                    </div>
                    <div>
                      {types.map((value) => {
                        return (
                          <div style={{ marginRight: 20 }}>
                            <Input props={{ width: 15, height: 15 }} type="radio" name="type" required checked={values.type === value} notShowRequired value={value} onChange={onChange} label={value} />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <Input style={values.type === "Yes" ? { width: '100%', maxWidth: 400 } : { display: "none" }} onChange={onChange} name="cage_id" title="Select Cage" required tag="select" >
                    <option>{textStatus.includes('cage') ? values.cage : 'Select a cage'}</option>
                    {cages.map((value) => {
                      return <option value={value.idCage}>{value.name}</option>;
                    })}
                  </Input>
                  {
                    !textStatus.includes('cage') &&
                    <div style={values.type === "Yes" ? { display: 'flex', alignItems: 'center', gap: 15 } : { display: 'none' }}>
                      <Input onChange={onChange} name="cage" title="Not found a Cage?" type="text" placeholder={'Write Here'} />
                      <Button disabled={!values.cage} onClick={postNewCage} style={{ height: 40, marginTop: 20, padding: '10px 20px' }} label={'Create a new Cage'} />
                    </div>
                  }
                </div>
              </div>
              {
                size.showInMobile ?
                  <section className="select-type-rack">
                    <h1>[ ] Rack Count</h1>
                    <Tabs options={options} onClick={setSelected} selected={selected} />
                    <h3>{selected === 'Added' ? 'Activate an existing rack below' : 'Disable a rack below'}</h3>
                    <Button typeButton='button' onClick={() => selectedTypes(selected)} style={{ width: '100%', color: '#FFF', background: selected === 'Added' ? added.length > 0 ? '#0F0742' : '#59975C' : churned.length > 0 ? '#0F0742' : '#B73D3D', borderRadius: 30, border: 'none' }} label={selected === 'Added' ? added.length > 0 ? `${added.length} Racks Added` : `Add Racks +` : churned.length > 0 ? `${churned.length} Racks Churned` : 'Churned Racks +'} />
                    <hr className="hr-divisor" />
                    {selected === 'Added' && <Button onClick={() => setOpenModalAdded(true)} typeButton='button' style={{ width: '100%', borderRadius: 30 }} label='Insert new non-existing rack' />}
                    <Button
                      disabled={!(Object.keys(values).length > 1 && (added.length > 0 || churned.length > 0))}
                      typeButton="submit"
                      style={{
                        width: "92%",
                        color: "#fff",
                        height: "46px",
                        border: 'none',
                      }}
                      label={"Finish insertion"}
                    />
                  </section>
                  :
                  <section className="content-select-type-rack-desktop">
                    <h1 style={{ fontSize: 18, fontWeight: 600 }}>[ ] Rack Count</h1>
                    <section className="select-type-rack-desktop">
                      <div>
                        <h1>Added</h1>
                        <p>Activate an existing rack</p>
                        {/* <Button typeButton='button' onClick={() => selectedTypes('Added')} style={{ width: '100%', borderRadius: 30, color: '#FFF', background: added.filter(el => !el.reserved).length > 0 ? '#0F0742' : '#59975C', border: 'none' }} label={added.filter(el => !el.reserved).length > 0 ? `${added.filter(el => !el.reserved).length} Racks Added` : `Add Racks +`} /> */}
                        <Button typeButton='button' onClick={() => selectedTypes('Added')} style={{ width: '100%', borderRadius: 30, color: '#FFF', background: '#59975C', border:"none"}} label={`Add Racks +`} />
                      </div>
                      <div>
                        <h1>Churned</h1>
                        <p>Disable a rack</p>
                        {/* <Button typeButton='button' onClick={() => selectedTypes('Churned')} style={{ width: '100%', borderRadius: 30, color: '#FFF', background: churned.length > 0 ? '#0F0742' : '#B73D3D', border: 'none' }} label={churned.length > 0 ? `${churned.length} Racks Churned` : 'Churned Racks +'} /> */}
                        <Button typeButton='button' onClick={() => selectedTypes('Churned')} style={{ width: '100%', borderRadius: 30, color: '#FFF', background: '#B73D3D', border: 'none' }} label={'Churned Racks +'} />
                      </div>
                      <div>
                        <h1>Added non-existing</h1>
                        <p>Insert new non-existing rack</p>
                        <Button onClick={() => setOpenModalAdded(true)} typeButton='button' style={{ width: '100%', borderRadius: 30 }} label='Insert' />
                      </div>
                      <div>
                        <h1>Reserved</h1>
                        <p>Reserve a rack</p>
                        {/* <Button typeButton='button' onClick={() => selectedTypes('Reserved')} style={{ width: '100%', borderRadius: 30, color: '#FFF', background: added.filter(el => el.reserved).length > 0 ? '#0F0742' : '#E89F17', border: 'none' }} label={added.filter(el => el.reserved).length > 0 ? `${added.filter(el => el.reserved).length} Racks Reserved` : 'Reserved Racks +'} /> */}
                        <Button typeButton='button' onClick={() => selectedTypes('Reserved')} style={{ width: '100%', borderRadius: 30, color: '#FFF', background: '#E89F17', border: 'none' }} label={'Reserved Racks +'} />
                      </div>
                    </section>
                    <Button
                      typeButton="submit"
                      style={{
                        width: "100%",
                        background: !(!!values.client_id && (added.length < 1 || churned.length < 1)) ? "#ccc" : "#00838D",
                        color: "#fff",
                        height: "46px",
                        border: 'none'
                      }}
                      disabled={!(!!values.client_id && (added.length < 1 || churned.length < 1))}
                      label={"Finish insertion"}
                    />
                  </section>
              }
            </form>
          </section>
          <ModalAddedItems
            setAdded={setEmptyAdded}
            open={openModalAdded}
            added={emptyAdded}
            pdus={pdus}
            setPdus={setPdus}
            setOpen={(data) => { setOpenModalAdded(data); return emptyAdded.every(element => added.includes(element)) ? null : setAdded(added.concat(emptyAdded)); }}
          />
          {
            openModalChurned &&
            <ModalChurned
              racks={dataRacks}
              type={selected === 'Churned' ? ['Added', 'Churned'] : ['Churned', 'Added']}
              base={selected === 'Churned' ? churned : added}
              setOpen={setOpenModalChurned}
              reserved={selected === 'Reserved'}
              churned={selected === 'Churned' ? (data) => setChurned(data) : (data) => setAdded(data)}
            />
          }
        </section>
      }

      <FooterStatus
        show={showFeedback}
        text={textStatus}
        cancel={() => setShowFeedback(false)}
      />
    </section >
  );
}

export default AddRoom;
